import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicabsonlinebooking() {



const cardData = {
  keyword: " Mumbai Cabs Online Booking ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai cabs online booking services, allowing customers to easily reserve taxis for local travel, airport transfers, outstation journeys, and corporate trips with just a few clicks. Our user-friendly online booking system ensures quick confirmations, transparent pricing, and no hidden charges. With a fleet of well-maintained air-conditioned sedans, SUVs, and luxury vehicles, we cater to solo travelers, families, and business clients. Our professional drivers, punctual service, and 24/7 customer support guarantee a smooth and stress-free travel experience across Mumbai and beyond. Velocity Cab is the trusted choice for convenient and secure online cab booking in Mumbai.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is one of the most popular outstation destinations from Mumbai, known for its lush green valleys, misty hills, and scenic waterfalls. Travelers booking a sedan cab can enjoy a comfortable drive via the Mumbai–Pune Expressway and visit attractions like Tiger Point, Bhushi Dam, and Lion’s Point for breathtaking views."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a beautiful coastal getaway near Mumbai famous for its clean beaches, sea forts, and relaxed vibe. Visitors can enjoy Alibaug Beach, Kolaba Fort, and Mandwa Jetty while experiencing a peaceful seaside escape perfect for weekend trips."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a serene hill station located in the Western Ghats, known for its lush greenery, waterfalls, and calm environment. It is ideal for meditation retreats, nature walks, and scenic drives through fog-covered mountains."
  },
  {
    title: "Matheran",
    description: "Matheran is India’s smallest hill station and a unique eco-friendly destination near Mumbai. Known for its vehicle-free environment, visitors can explore viewpoints like Panorama Point and Echo Point while enjoying horse rides and walking trails."
  },
  {
    title: "Nashik",
    description: "Nashik is a major pilgrimage and wine tourism destination near Mumbai, famous for the Trimbakeshwar Temple and Sula Vineyards. Travelers can enjoy spiritual visits, vineyard tours, and scenic riverfront experiences along the Godavari River."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India’s most important pilgrimage sites dedicated to Sai Baba. Visitors can visit the Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi while experiencing a peaceful spiritual atmosphere."
  },
  {
    title: "Saputara",
    description: "Saputara is a picturesque hill station in Gujarat near the Maharashtra border, known for its cool climate, lakes, and viewpoints. It offers boating, ropeway rides, and scenic sunset spots ideal for family trips."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station near Mumbai famous for its strawberry farms, Table Land plateau, and scenic valley views. It is perfect for relaxing holidays and nature photography."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for its cool weather, strawberry farms, and viewpoints like Arthur’s Seat and Elephant’s Head Point. It is ideal for long weekend getaways from Mumbai."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is a peaceful coastal destination near Mumbai known for its white sand, clear waters, and water sports activities. It is a great spot for relaxation, camping, and seaside drives."
  }
],



services: [
{
name: "Online Cab Booking Mumbai",
description: "Online cab booking Mumbai offers a fast, convenient, and reliable way to book taxis for city rides, airport transfers, and outstation travel. With just a few clicks, customers can choose their preferred vehicle type, pickup location, and travel schedule without any hassle. This service is ideal for busy professionals, families, and travelers who want quick and easy transportation solutions. Real-time availability ensures instant confirmation and timely service for all bookings. Customers can select from a wide range of vehicles including sedan, SUV, and premium cars based on their travel needs. Transparent pricing with no hidden charges makes it easy to plan travel budgets. With 24x7 service and secure payment options, online cab booking in Mumbai ensures a smooth and stress-free travel experience."
},
{
name: "Book Taxi Online Mumbai",
description: "Book taxi online Mumbai allows customers to reserve cabs quickly with instant confirmation and flexible travel options. This service is perfect for city travel, airport pickups, and long-distance trips. Users can easily select vehicle type, travel date, and pickup location through online platforms. Transparent pricing ensures clarity in fares without hidden costs. Professional drivers ensure safe and timely service. It is the most convenient way to book taxis in Mumbai."
},
{
name: "Mumbai Cab Reservation Online",
description: "Mumbai cab reservation online provides a seamless booking experience for customers looking for reliable transportation. This service allows users to pre-book cabs for planned trips with flexible scheduling options. Multiple vehicle choices are available based on comfort and budget. Online booking ensures availability of cabs during peak hours. Professional drivers ensure safe and efficient travel. It is a reliable option for advance travel planning."
},
{
name: "Cheap Cab Booking Mumbai",
description: "Cheap cab booking Mumbai offers budget-friendly transportation options for city and outstation travel without compromising comfort and safety. This service is ideal for cost-conscious travelers looking for reliable cab services at affordable rates. Economical vehicle options are available for lower fares. Transparent pricing ensures no hidden charges. Professional drivers ensure smooth travel. It is a perfect balance of affordability and convenience."
},
{
name: "Taxi Booking App Mumbai",
description: "Taxi booking app Mumbai provides a user-friendly platform to book cabs anytime, anywhere with just a few taps. This service offers real-time tracking, instant confirmation, and multiple payment options for convenience. Customers can choose from various vehicle types including sedan and SUV. The app ensures quick response and efficient service. It is ideal for daily commuters and frequent travelers. It makes cab booking simple and efficient."
},
{
name: "AC Cab Booking Mumbai",
description: "AC cab booking Mumbai ensures a comfortable travel experience with air-conditioned vehicles for both city and long-distance journeys. This service is ideal for travelers who prefer a pleasant environment during travel. Clean interiors and well-maintained AC systems enhance comfort. Flexible booking options allow easy planning. Professional drivers ensure safe and timely service. It guarantees a relaxing journey."
},
{
name: "SUV Cab Booking Mumbai",
description: "SUV cab booking Mumbai is ideal for group travel and passengers needing extra space and comfort. SUVs provide spacious seating and better performance for long-distance travel. This service is suitable for families, corporate groups, and tourists. Professional drivers ensure safe and smooth travel. Flexible booking options are available. It offers a premium travel experience."
},
{
name: "One Way Cab Booking Mumbai",
description: "One way cab booking Mumbai provides cost-effective travel solutions for single-side journeys without return charges. This service is ideal for airport drops, intercity travel, and business trips. Customers benefit from competitive pricing and flexible pickup timing. Professional drivers ensure timely service. Multiple vehicle options are available. It is a convenient and affordable travel option."
},
{
name: "Outstation Cab Booking Mumbai",
description: "Outstation cab booking Mumbai offers reliable transportation for long-distance travel to destinations like Pune, Nashik, Lonavala, Shirdi, and Goa. This service ensures comfortable travel with well-maintained vehicles and experienced drivers. Flexible packages include one way and round trip options. Transparent pricing ensures no hidden charges. It is ideal for family trips and corporate travel. It ensures a smooth and hassle-free journey."
},
{
name: "Airport Cab Booking Mumbai",
description: "Airport cab booking Mumbai provides quick and reliable transportation for airport pickups and drops with timely service. This service ensures smooth travel to and from Mumbai Airport with professional drivers. Real-time flight tracking ensures accurate pickup timing. Spacious vehicles provide comfort for passengers and luggage. Flexible booking options make it convenient. It ensures a stress-free airport transfer experience."
}
],

tableData: [
["Online Cab Booking Mumbai","Book Taxi Online Mumbai"],
["Mumbai Cab Reservation Online","Cheap Cab Booking Mumbai"],
["Taxi Booking App Mumbai","AC Cab Booking Mumbai"],
["SUV Cab Booking Mumbai","One Way Cab Booking Mumbai"],
["Outstation Cab Booking Mumbai","Airport Cab Booking Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking",
    WhyChoosedescription: "Velocity Cabs offers simple and hassle-free Mumbai cabs online booking, allowing customers to book their ride instantly from anywhere with quick confirmation."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and affordable pricing for online cab booking in Mumbai. Customers receive complete fare details including charges, tolls, and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Booking Availability",
    WhyChoosedescription: "Our Mumbai online cab booking service operates 24/7. Whether you need early morning travel or late-night rides, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and stress-free travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury cars, and Tempo Travellers suitable for all travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports across Mumbai for seamless travel."
  },
  {
    WhyChooseheading: "Trusted Online Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Mumbai cab bookings due to professional drivers, comfortable vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Can I book cab online in Mumbai?", answer: "Yes, Velocity Cabs provides easy online cab booking services in Mumbai for local and outstation travel." },
  { question: "Is online cab booking available 24 hours?", answer: "Yes, our Mumbai cab booking service operates 24/7 for customer convenience." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury cars, and Tempo Travellers." },
  { question: "Can I book cab for airport transfer online?", answer: "Yes, you can book airport pickup and drop services online for Mumbai Airport." },
  { question: "Is one-way cab booking available?", answer: "Yes, we provide one-way as well as round-trip cab booking options." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and railway stations across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during peak travel time and weekends." },
  { question: "Can I modify or cancel my booking?", answer: "Yes, bookings can be modified or canceled as per our policy." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Mehta",
    feedback:
      "Easy access to an online cab in Mumbai made my travel completely stress-free. The car arrived on time, was clean, and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Smooth experience with an online cab service in Mumbai. Everything from pickup to drop was punctual, and the journey felt safe and well-organized.",
    rating: 5
  }
];
























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const mumbaiCabsOnlineJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Cabs Online Booking | Velocity Cabs",
  "description": "Book a cab online in Mumbai for city trips, airport transfers, or outstation travel. AC, SUV, and sedan taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Online Cab Booking Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Online Cab Booking",
        "description": "Book a cab online for one-way travel in Mumbai with AC, SUV, or sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Online Cab Booking",
        "description": "Book a cab online for comfortable round-trip travel in Mumbai with AC, SUV, or sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai Cabs Online Booking | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a cab online in Mumbai for city trips, airport transfers, or outstation travel. AC, SUV, and sedan taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiCabsOnlineJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicabsonlinebooking;